import { createVuetify } from 'vuetify'
import { VVideo } from 'vuetify/labs/VVideo'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { en } from 'vuetify/locale'

import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'


// Opcional: define tema para mantener colores del diseñador
const theme = {
  defaultTheme: 'azules',
  themes: {
    lightTheme: {
      dark: false,
      colors: {
        primary: '#d0b98a',
        secondary: '#f1eee5',
        third: '#e2d7c0',
        fourth: '#d7c4a0',
        fifth: '#e9e3d3',
      },
    },
     darkTheme: {
      dark: true,
      colors: {
        primary: '#757030',
        secondary: '#635e2e',
        third: '#e2d7c0',
        fourth: '#d7c4a0',
        fifth: '#e9e3d3',
      },
    },
     azules: {
      dark: false,
      colors: {
        primary: '#0D47A1',   // azul profundo principal
        secondary: '#1976D2', // azul medio para acentos
        third: '#42A5F5',     // azul más claro / detalles
        fourth: '#90CAF9',    // azul suave para fondos o cards
        fifth: '#E3F2FD',     // azul muy claro / casi blanco para detalles
        success: '#4d8e17ff'
      },
    },
  },
  defaults: {
    global: {
      style: {
        fontFamily: 'Inter Tight, sans-serif',
      },
    },
  },
}

const eu = {
  name: 'eu',
  shortDays: ['Al', 'Ar', 'Az', 'Og', 'Ol', 'Lr', 'Ig'],
  days: [
    'Astelehena',
    'Asteartea',
    'Asteazkena',
    'Osteguna',
    'Ostirala',
    'Larunbata',
    'Igandea',
  ],
  shortMonths: [
    'Urt', 'Ots', 'Mar', 'Api', 'Mai', 'Eka',
    'Uzt', 'Abu', 'Ira', 'Urr', 'Aza', 'Abe',
  ],
  months: [
    'Urtarrila', 'Otsaila', 'Martxoa', 'Apirila',
    'Maiatza', 'Ekaina', 'Uztaila', 'Abuztua',
    'Iraila', 'Urria', 'Azaroa', 'Abendua',
  ],
  firstDayOfWeek: 1,
  label: { ok: 'Ados', cancel: 'Utzi' },
}

export default createVuetify({
  components: {
    ...components,
    VVideo,
  },
  directives,
   locale: {
    locale: 'eu',
    fallback: 'en',
    messages: { eu,en },
  },
  theme,
  icons: {
    defaultSet: 'mdi', 
  },
})
